export enum CancellationReason {
  OBJECT_AT_RISK_NOT_EXIST_ANY_MORE = 'notExist',
  YEARLY_RENEWAL = 'yearlyRenewal',
  MOVE_TO_NEW_COMPANY = 'newCompany',
}

export enum CancelSurveyReason {
  TOO_EXPENSIVE = 'tooExpensive',
  NOT_NEEDED = 'notNeeded',
  MOVED_TO_NEW_COMPANY = 'movedToNewCompany',
  HEALTH_ASSESSMENT_RESULT = 'healthAssesmentResult',
  OTHER_REASON = 'otherReason',
}
